/* eslint-disable @typescript-eslint/no-unused-vars */
import { Select } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

export default styled(Select)(
  ({ theme, ownerState }: { theme?: Theme | any; ownerState: any }) => {
    const { palette } = theme;
    const { width, variant } = ownerState;

    const { secondary } = palette;

    let border = '';

    if (variant === 'outlined') border = `1px solid ${secondary.main}`;

    return {
      width: width || 'auto',
      height: '30px',
      color: 'white',
      border
    };
  }
);
